/** "What you can become": the six identity paths, shown on the welcome screen and in Office. Display only, nothing to pick. */
import { useStore } from '../store';

/** Names and blurbs are PROPOSED placeholder copy, not approved text. */
export const PATHS = [
  { id: 'zoo', name: 'Zoo', text: 'Guests, rates and marketing. No hunting. Photo tours and education.' },
  { id: 'hunting_ranch', name: 'Hunting ranch', text: 'Paddocks only, no display animals. Lodge, trophy and management hunts.' },
  { id: 'conservation_breeder', name: 'Conservation breeder', text: 'Rare and endangered species, genetic exchange, rewilding herds overseas.' },
  { id: 'rancher', name: 'Rancher', text: 'Breed stock for other ranches, proven breeders, jerky and meat products.' },
  { id: 'breeder', name: 'Breeder', text: 'From a small pen to a full breeding facility. Morphs and bloodlines.' },
  { id: 'conservationist', name: 'Conservationist', text: 'Protect habitat, fund programs, earn trust with governments and partners.' },
] as const;

export function PathCards({ compact = false }: { compact?: boolean }) {
  const { sim } = useStore();
  return (
    <div>
      <div style={compact ? 'display:grid;grid-template-columns:1fr 1fr;gap:6px;margin-top:8px' : ''}>
        {PATHS.map((p) => {
          const level = compact ? undefined : sim.identity?.paths.find((x) => x.id === p.id)?.level;
          return (
            <div key={p.id} class="card" style={`border:var(--ui-border);background:var(--ui-parchment-soft);margin-top:${compact ? 0 : 8}px;padding:${compact ? '8px 9px' : '10px 12px'}`}>
              <div class="row-value" style={compact ? 'font-size:14px' : ''}>{p.name}{level !== undefined && level > 0 ? ` - level ${level}` : ''}</div>
              <div class="row-label" style={`text-transform:none;letter-spacing:0.01em;white-space:normal;${compact ? 'font-size:10.5px;line-height:1.25;margin-top:2px' : ''}`}>{p.text}</div>
            </div>
          );
        })}
      </div>
      <p style="font-size:11.5px;color:var(--ui-ink-soft);margin-top:8px;text-align:center">
        Nothing to pick. Every path is open from day one, mix them freely. Your first actions start a path. Descriptions are proposed placeholder text.
      </p>
    </div>
  );
}
